import type { PageLoadMetric } from '@atlassian/browser-metrics/page-load-metric';

import { createPageLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { NOT_FOUND_LOAD_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';
export const NOT_FOUND_PAGE_LOAD: PageLoadMetric = createPageLoadMetric({
	key: NOT_FOUND_LOAD_KEY,
});
